// Official BLTR 2026 assets (served from /public/assets).
const KV = "/assets/kv";
const IC = "/assets/icons";
const M = "/assets/mascots";

export const ASSETS = {
  // Brand
  logo: `${M}/logo.webp`,
  // Mascot hero renders (official, transparent)
  trioHore: `${M}/trio-hore.webp`, // parrot + elephant + monkey dancing
  balapKarung: `${M}/balap-karung.png`, // sack race trio
  // Environment / KV decorations
  skyScene1: `${KV}/kv-03.png`,
  skyScene2: `${KV}/kv-04.png`,
  cloud1: `${KV}/kv-05.png`,
  cloud2: `${KV}/kv-06.png`,
  cloud3: `${KV}/kv-07.png`,
  cloud4: `${KV}/kv-08.png`,
  bushes1: `${KV}/kv-09.png`,
  bushes2: `${KV}/kv-10.png`,
  waterStrip: `${KV}/kv-11.png`,
  palm1: `${KV}/kv-12.png`,
  palm2: `${KV}/kv-13.png`,
  palm3: `${KV}/kv-14.png`,
  palm4: `${KV}/kv-15.png`,
  beachStrip: `${KV}/kv-16.png`,
  sandStrip: `${KV}/kv-17.png`,
  coralStripes: `${KV}/kv-18.png`,
  raceTrack: `${KV}/kv-19.png`,
  beachBall: `${KV}/kv-20.png`,
  swimRing: `${KV}/kv-21.png`,
};

// Official activity / feature icons
export const ICONS = {
  ribbonSm: `${IC}/icon-41.png`,
  ribbonLg: `${IC}/icon-43.png`,
  chevron: `${IC}/icon-44.png`,
  signboard: `${IC}/icon-45.png`,
  locationPin: `${IC}/icon-46.png`,
  gift: `${IC}/icon-47.png`,
  palette: `${IC}/icon-48.png`, // face painting
  trophy: `${IC}/icon-49.png`, // kids competition
  tickets: `${IC}/icon-50.png`,
  micTicket: `${IC}/icon-51.png`, // live show / meet & greet
  jersey: `${IC}/icon-52.png`, // racepack
  finishFlag: `${IC}/icon-53.png`,
  stopwatch: `${IC}/icon-54.png`, // fun run
};
